<!--@Deprecated use /decisioning-criteria/components/CriterionInputComponents/...-->
<template>
    <div class="CriterionBooleanInput">
        <FormElement :label="hideTitle ? undefined : schema.title">
            <template v-if="schema.description" #labelHint>
                <div
                    v-tooltip="schema.description"
                    class="CriterionEnumInput__hintIcon"
                >
                    <FontAwesomeIcon :icon="faQuestionCircle" />
                </div>
            </template>
            <FormInput :invalid="showValidationErrors && (showError || accessed) && hasError" force-error-slot>
                <Dropdown
                    :options="booleanOptions"
                    :selected="convertBoolToOptions(value)"
                    @input="onBooleanFieldChange($event)"
                />
                <template v-if="showValidationErrors && (showError || accessed) && hasError" #errorMessage>
                    {{ errorMessage }}
                </template>
                <template v-if="deletable" #actionButtons>
                    <NewButton
                        variant="flat"
                        size="icon-sm"
                        color="secondary"
                        class="JsonSchemaForm__deleteIcon"
                        @click="$emit('delete')"
                    >
                        <EidIcon :icon-src="faXmark" alt="delete" />
                    </NewButton>
                </template>
            </FormInput>
        </FormElement>
    </div>
</template>

<script lang="ts">
    import { Component } from '@evidentid/vue-property-decorator';

    import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
    import { faXmark } from '@fortawesome/pro-light-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    import Dropdown from '@evidentid/dashboard-commons/components/Dropdown/Dropdown.vue';
    import { DropdownOption } from '@evidentid/dashboard-commons/components/Dropdown/types';
    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';
    import { FormElement, FormInput } from '@evidentid/dashboard-commons/components/Form';
    import { JsonSchemaBoolean } from '@evidentid/json-schema/interfaces/JsonSchema';

    import NewButton from '@/components/new-button/NewButton.vue';

    import AbstractCriterionInput from './AbstractCriterionInput';

    @Component({
        emits: [ 'delete', 'input' ],
        components: { Dropdown, EidIcon, FormInput, FormElement, FontAwesomeIcon, NewButton },
    })
    export default class CriterionBooleanInput extends AbstractCriterionInput<JsonSchemaBoolean, boolean> {
        // @Deprecated use /decisioning-criteria/components/CriterionInputComponents/...
        private faXmark = faXmark;
        private faQuestionCircle = faQuestionCircle;

        private booleanOptions: DropdownOption[] = [
            { label: 'Yes', value: true },
            { label: 'No', value: false },
        ];

        /** Only a real boolean names an option. A Yes/No value that reached this control as the
         * "YES"/"NO" text would otherwise read as Yes whatever it said, every non-empty string
         * being truthy; showing nothing selected leaves the validation error it has already
         * failed as the thing the operator acts on.
         */
        private convertBoolToOptions(value: boolean | undefined): DropdownOption[] {
            return typeof value === 'boolean' ? [ { label: value ? 'Yes' : 'No', value } ] : [];
        }

        private onBooleanFieldChange(option: DropdownOption): void {
            this.$emit('input', option.value);
        }
    }
</script>
